import React from "react";

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h2>RENCONTRER L'ÉQUIPE</h2>
          <p>
            Notre équipe d'experts passionnés est prête à travailler avec vous.
          </p>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                  <div className="thumbnail">
                    {" "}
                    <img src={d.img} alt="..." className="team-img" />
                    <div className="caption">
                      <h4>{d.name}</h4>
                      <p>{d.job}</p>
                    </div>
                  </div>
                  <div className="welcome-txt">
                    Bienvenue chez Bonheur DD – Là où les soins compatissants
                    rencontrent une vie confortable !
                    <br />
                    <br /> À Bonheur DD, nous comprenons que choisir les bons
                    soins pour vous-même ou pour votre proche est une décision
                    importante. Notre équipe dévouée est ravie de vous
                    accueillir chaleureusement et sincèrement alors que vous
                    explorez les possibilités d’une résidence pour personnes
                    âgées exceptionnelle. Ici, à Bonheur DD, nous accordons la
                    priorité au bien-être et au bonheur de nos résidents. <br />{" "}
                    <br />
                    Notre engagement à fournir des soins empreints de
                    compassion, à favoriser une communauté dynamique et à créer
                    un environnement confortable et sécurisé nous distingue.
                    Nous nous efforçons de créer un foyer où les résidents
                    peuvent profiter de leurs années d'or avec dignité, respect
                    et sentiment d'appartenance. Explorez notre site Web pour en
                    savoir plus sur nos installations ultramodernes, nos plans
                    de soins personnalisés, nos activités engageantes et la
                    communauté chaleureuse et solidaire que nous avons cultivée.
                    Que vous ou votre proche ayez besoin de services de vie
                    assistée, de soins de la mémoire ou de réadaptation, nous
                    avons des programmes adaptés pour répondre à divers besoins.
                    <br />
                    <br />
                    Bienvenue dans la famille Bonheur DD !
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
